import { colors } from '@xcritical/theme';

export const blanketThemeNamespace = '@xcritical\\blanket';

export const defaultBlanketTheme = {
  background: colors.CHAROCOAL,
  color: colors.WHITE,
  opacity: 0.5,
  zIndex: 100,
  position: 'fixed',
  right: 0,
  top: 0,
  bottom: 0,
  left: 0,
  transition: 'opacity 220ms',
  boxSizing: 'border-box',
};
